import styled from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
import { responsiveProperty } from 'modules/utils/responsiveProperty/responsiveProperty';
import { getCellCSS } from './utils';
const MAX_CELLS = 12;
const containerWidth = responsiveProperty('maxWidth', {
    base: '100%',
    lg: '87rem',
    xl: '102rem',
    xxl: '130rem',
});
const containerPadding = responsiveProperty('padding', {
    base: `0 ${themeGet('spacing.lg')}`,
    sm: `0 ${themeGet('spacing.4xl')}`,
});
const gridGap = responsiveProperty('gap', {
    base: 'lg',
    sm: '2xl',
});
export const GridContainer = styled.div `
  margin: 0 auto;
  width: 100%;
  ${containerWidth};
  ${containerPadding};
`;
export const GridRow = styled.div `
  display: grid;
  grid-template-columns: repeat(${MAX_CELLS}, 1fr);
  grid-template-rows: 1fr;
  align-content: center;
  place-items: stretch stretch;

  ${gridGap};
`;
export const GridCell = styled.div `
  ${({ width }) => getCellCSS(width)}
`;
